import {ExpoScaleEase} from 'gsap';

module.exports = (tl, instance, setLabel) => {
    const picture1 = instance.pic1;
    tl.set(picture1.scale, {x: 1, y: 1}, setLabel);
    tl.set(picture1, {z: -0.3}, setLabel);
    tl.to(picture1, 9, {z: -0.05, ease: ExpoScaleEase.config(1, 1.2)}, setLabel);
    tl.to(picture1.scale, 9, {x: 1.2, y: 1.2, ease: ExpoScaleEase.config(1, 1.2)}, setLabel);
}


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/illustrations/AddApotheosisCustomTimeline.js